import { Component } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { NgAnalyzeModulesHost } from '@angular/compiler';
import { HttpClient } from '@angular/common/http';

interface Item {
  value: string;
  view: string;
}



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'osteowebapp';

  constructor(private http : HttpClient) {}

  posting : boolean = false;
  hasResults = {
    cycle1: false,
    cycle2: false,
    cycle3: false,
    cycle4: false,
    cycle5: false,
    cycle6: false
  };
  results = {
    cycle1: null,
    cycle2: null,
    cycle3: null,
    cycle4: null,
    cycle5: null,
    cycle6: null,

  };

  // Deprecated
  c1_cumdose1 : number;
  c1_plt11 : number;
  c1_plt21 : number;
  c1_wbc11 : number;
  c1_wbc21 : number;
  c1_neut11 : number;
  c1_neut21 : number;
  c1_ren11 : number;
  c1_ht1 : number;
  c1_sex : number;

  c2_highotox1 : number;
  c2_stdcumdose2 : number;
  c2_trt : number;
  c2_deltawbc22 : number;
  c2_wbc1 : number;
  c2_wbc2 : number;

  c3_highotox1 : number;
  c3_highotox2 : number;
  c3_stdcumdose3 : number;
  c3_plt1 : number;
  c3_plt3 : number;

  c4_highotox1 : number;
  c4_highotox2 : number;
  c4_highotox3 : number;
  c4_gender : number;
  c4_wbc1 : number;
  c4_wbc4 : number;
  c4_wbc4_2: number;
  c4_plt1 : number;
  c4_plt4 : number;
  c4_neut4 : number;


  c5_highotox3 : number;
  c5_highotox4 : number;
  c5_gender : number;
  c5_wbc1 : number;
  c5_wbc5 : number;
  c5_wbc5_2 : number;


  c6_highotox2 : number;
  c6_highotox3 : number;
  c6_highotox4 : number;
  c6_highotox5 : number;
  c6_wbc1 : number;
  c6_wbc6_2 : number;
  c6_plt1 : number;
  c6_plt6 : number;

  options = { 
    cycle1: {
      sex: [
        {value: 1, view: "Male"},
        {value: 0, view: "Female"}
      ]
    },
    cycle2: {
      tox1: [
        {value: 0, view: "Low Toxicity"},
        {value: 1, view: "High Toxicity"}
      ],
      trt: [
        {value: 0, view: "Reg-C"},
        {value: 1, view: "Reg-DI"}
      ]
    },
    cycle3: {
      tox1: [
        {value: 0, view: "Low Toxicity"},
        {value: 1, view: "High Toxicity"}
      ],
      tox2: [
        {value: 0, view: "Low Toxicity"},
        {value: 1, view: "High Toxicity"}
      ],
      surgery: [
        {value: 0, view: "Early"},
        {value: 1, view: "On Time"}
      ],
      sex: [
        {value: 0, view: "Male"},
        {value: 1, view: "Female"}
      ],
      trt: [
        {value: 0, view: "Reg-C"},
        {value: 1, view: "Reg-DI"}
      ]
    },
    cycle4: {
      tox1: [
        {value: 0, view: "Low Toxicity"},
        {value: 1, view: "High Toxicity"}
      ],
      tox2: [
        {value: 0, view: "Low Toxicity"},
        {value: 1, view: "High Toxicity"}
      ],
      tox3: [
        {value: 0, view: "Low Toxicity"},
        {value: 1, view: "High Toxicity"}
      ],
      trt: [
        {value: 0, view: "Reg-C"},
        {value: 1, view: "Reg-DI"}
      ],
      gender: [
        {value: 1, view: "Male"},
        {value: 0, view: "Female"}
      ]
    },
    cycle5: {
      tox3: [
        {value: 0, view: "Low Toxicity"},
        {value: 1, view: "High Toxicity"}
      ],
      tox4: [
        {value: 0, view: "Low Toxicity"},
        {value: 1, view: "High Toxicity"}
      ], 
      gender: [
        {value: 1, view: "Male"},
        {value: 0, view: "Female"}
      ]
    },
    cycle6: {
      tox2: [
        {value: 0, view: "Low Toxicity"},
        {value: 1, view: "High Toxicity"}
      ],
      tox3: [
        {value: 0, view: "Low Toxicity"},
        {value: 1, view: "High Toxicity"}
      ],
      tox4: [
        {value: 0, view: "Low Toxicity"},
        {value: 1, view: "High Toxicity"}
      ],
      tox5: [
        {value: 0, view: "Low Toxicity"},
        {value: 1, view: "High Toxicity"}
      ],
      trt: [
        {value: 0, view: "Reg-C"},
        {value: 1, view: "Reg-DI"}
      ],
      sex: [
        {value: 1, view: "Male"},
        {value: 0, view: "Female"}
      ]
    }
    
  };

  onSubmit1 = () => {
    this.posting = true;
    
    this.http.get('https://3jrk55f92b.execute-api.eu-central-1.amazonaws.com/prod/ciclo1', {
      params: {
        cumdose1: this.c1_cumdose1.toString(),
        plt11: this.c1_plt11.toString(),
        wbc21: this.c1_wbc21.toString(),
        wbc11: this.c1_wbc11.toString(),
        neut11: this.c1_neut11.toString(),
        neut21: this.c1_neut21.toString(),
        plt21: this.c1_plt21.toString(),
        ht1: this.c1_ht1.toString(),
        sex: this.c1_sex.toString(),
        ren11: this.c1_ren11.toString()
      }
    }).subscribe((data) => {
      console.log(data);
      let res = JSON.parse(data["Payload"]);
      if (res.result == null) {
        alert("An error was encountered, please check the inputs. If the error persists please contact marta.spreafico@polimi.it");
        this.posting = false;
        this.hasResults.cycle1 = false;

      } else {
        this.results.cycle1 = JSON.parse(data["Payload"]).result[0];
        this.posting = false;
        this.hasResults.cycle1 = true;
      }
    } )
  };


  onSubmit2 = () => {
    this.posting = true;
    console.log({
      highotox1: this.c2_highotox1.toString(),
      stdcumdose2: this.c2_stdcumdose2.toString(),
      trt: this.c2_trt.toString(),
      deltawbc22: (Math.log(this.c2_wbc2) - Math.log(this.c2_wbc1))
    })
    this.http.get('https://3jrk55f92b.execute-api.eu-central-1.amazonaws.com/prod/ciclo2', {
      params: {
        highotox1: this.c2_highotox1.toString(),
        stdcumdose2: (this.c2_stdcumdose2 /(2*175) * 100).toString(),
        trt: this.c2_trt.toString(),
        deltawbc22: (Math.log(this.c2_wbc2) - Math.log(this.c2_wbc1)).toString()
      }
    }).subscribe((data) => {
      console.log(data);
      let res = JSON.parse(data["Payload"]);
      if (res.result == null) {
        alert("An error was encountered, please check the inputs. If the error persists please contact marta.spreafico@polimi.it");
        this.posting = false;
        this.hasResults.cycle2 = false;

      } else {
        this.results.cycle2 = JSON.parse(data["Payload"]).result[0];
        this.posting = false;
        this.hasResults.cycle2 = true;
      }
    } )
  }

  onSubmit3 = () => {
    this.posting = true;
    
    this.http.get('https://3jrk55f92b.execute-api.eu-central-1.amazonaws.com/prod/ciclo3', {
      params: {
        highotox1: this.c3_highotox1.toString(),
        highotox2: this.c3_highotox2.toString(),
        stdcumdose3: (this.c3_stdcumdose3 /(3*175)*100 ).toString(),
        deltaplt3: (Math.log(this.c3_plt3) - Math.log(this.c3_plt1)).toString()
      }
    }).subscribe((data) => {
      console.log(data);
      let res = JSON.parse(data["Payload"]);
      if (res.result == null) {
        alert("An error was encountered, please check the inputs. If the error persists please contact marta.spreafico@polimi.it");
        this.posting = false;
        this.hasResults.cycle3 = false;

      } else {
        this.results.cycle3 = JSON.parse(data["Payload"]).result[0];
        this.posting = false;
        this.hasResults.cycle3 = true;
      }
    } )
  };

  onSubmit4 = () => {
    this.posting = true;
    
    this.http.get('https://3jrk55f92b.execute-api.eu-central-1.amazonaws.com/prod/ciclo4', {
      params: {
        highotox1: this.c4_highotox1.toString(),
        highotox2: this.c4_highotox2.toString(),
        highotox3: this.c4_highotox3.toString(),
        gender: this.c4_gender.toString(),
        deltawbc24: (Math.log(this.c4_wbc4_2) - Math.log(this.c4_wbc1)).toString(),
        deltaplt4: (Math.log(this.c4_plt4) - Math.log(this.c4_plt1)).toString(),
        neutwbc4: (this.c4_neut4/this.c4_wbc4).toString()

      }
    }).subscribe((data) => {
      console.log(data);
      let res = JSON.parse(data["Payload"]);
      if (res.result == null) {
        alert("An error was encountered, please check the inputs. If the error persists please contact marta.spreafico@polimi.it");
        this.posting = false;
        this.hasResults.cycle4 = false;

      } else {
        this.results.cycle4 = JSON.parse(data["Payload"]).result[0];
        this.posting = false;
        this.hasResults.cycle4 = true;
      }
      
    } )
  };
  // df_w$del_alkldh15 <- log(alk1.1)-log(alk1.5)  +log(ldh1.1)-log(ldh1.5)
  // df_w$del_wbc51 <- log(WBC2.5)-log(WBC1.1)

  onSubmit5 = () => {
    this.posting = true;
    
    this.http.get('https://3jrk55f92b.execute-api.eu-central-1.amazonaws.com/prod/ciclo5', {
      params: {
        highotox3: this.c5_highotox3.toString(),
        highotox4: this.c5_highotox4.toString(),

        gender: this.c5_gender.toString(),
        deltawbc15: (Math.log(this.c5_wbc5_2) - Math.log(this.c5_wbc1)).toString(),
        deltawbc25: (Math.log(this.c5_wbc5) - Math.log(this.c5_wbc1)).toString()

      }
    }).subscribe((data) => {
      console.log(data);
      let res = JSON.parse(data["Payload"]);
      if (res.result == null) {
        alert("An error was encountered, please check the inputs. If the error persists please contact marta.spreafico@polimi.it");
        this.posting = false;
        this.hasResults.cycle5 = false;

      } else {
        this.results.cycle5 = JSON.parse(data["Payload"]).result[0];
        this.posting = false;
        this.hasResults.cycle5 = true;
      }
    } )
  };



  onSubmit6 = () => {
    this.posting = true;
    
    this.http.get('https://3jrk55f92b.execute-api.eu-central-1.amazonaws.com/prod/ciclo6', {
      params: {
        highotox2: this.c6_highotox2.toString(),
        highotox3: this.c6_highotox3.toString(),
        highotox4: this.c6_highotox4.toString(),
        highotox5: this.c6_highotox5.toString(),

        deltawbc26: (Math.log(this.c6_wbc6_2) - Math.log(this.c6_wbc1)).toString(),
        deltaplt16: (Math.log(this.c6_plt6) - Math.log(this.c6_plt1)).toString()

      }
    }).subscribe((data) => {
      console.log(data);
      let res = JSON.parse(data["Payload"]);
      if (res.result == null) {
        alert("An error was encountered, please check the inputs. If the error persists please contact marta.spreafico@polimi.it");
        this.posting = false;
        this.hasResults.cycle6 = false;

      } else {
        this.results.cycle6 = JSON.parse(data["Payload"]).result[0];
        this.posting = false;
        this.hasResults.cycle6 = true;
      }
      
    } )
  };
  
}
